import { render, staticRenderFns } from "./TrainingStepClassification.vue?vue&type=template&id=50366758&scoped=true&"
import script from "./TrainingStepClassification.vue?vue&type=script&lang=js&"
export * from "./TrainingStepClassification.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStepClassification.vue?vue&type=style&index=0&id=50366758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50366758",
  null
  
)

export default component.exports